import { useNavigate } from "@reach/router";
import { useMemo, useEffect, useState, useRef } from "react";
import { usePlaylist, useSingleSong } from "../../../../hooks/useApi";
import { T } from "../../../../hooks/useLanguage";
import "../styles/artists.scss";
import LoadableImage from "../../../basic/LoadableImage";
import DefaultArtistCover from "../../../basic/DefaultArtistCover";

export default function Artists({ radio }) {
  const lastUpdateRef = useRef(0);
  const [randomSongs, setRandomSongs] = useState([]);
  const navigate = useNavigate();
  const { song } = useSingleSong(
    radio?.radioid,
    radio?.playing,
    radio?.playingsongid
  );

  const playlistid = song?.playlistid;

  const { songs } = usePlaylist(radio?.radioid, playlistid, true, 0, 400);
  const handleSelectArtist = (artist) => {
    navigate(`/sonicbox/${radio.nameseo}?s=${artist}`);
  };

  useEffect(() => {
    if (!songs || songs.length === 0) return;
    const newSongs = [];
    for (let i = 0; i < songs?.length; i++) {
      const randomIndex = Math.floor(Math.random() * songs.length);
      if (!newSongs.includes(songs[randomIndex])) {
        newSongs.push(songs[randomIndex]);
      }
    }
    const now = new Date().getTime();
    if (now - lastUpdateRef.current > 60 * 1000) {
      lastUpdateRef.current = now;
      setRandomSongs(newSongs);
    }
  }, [songs]);

  const splittedArtists = useMemo(() => {
    if (!Array.isArray(randomSongs)) {
      return [];
    }
    const result = randomSongs.map((song) => {
      const splitted = song.artist
        .split(", ")
        .join(" | ")
        .split("; ")
        .join(" | ")
        .split(" - ")
        .join(" | ")
        .split(" | ");
      return {
        ...song,
        artist: splitted[0],
        splitted: splitted.length > 1,
      };
    });
    const artists = result.flat();
    return artists;
  }, [randomSongs]);

  const uniqueArtists = useMemo(() => {
    const uniqueArtists = [];
    splittedArtists.forEach((artist) => {
      const found = uniqueArtists.findIndex((a) => a.artist === artist.artist);
      if (found < 0) {
        uniqueArtists.push(artist);
      } else {
        const existingArtist = uniqueArtists[found];

        if (existingArtist.splitted && !artist.splitted) {
          uniqueArtists[found] = artist;
        } else if (existingArtist.cover === "" && artist.cover !== "") {
          uniqueArtists[found] = artist;
        }
      }
    });
    return uniqueArtists;
  }, [splittedArtists]);

  const artists = useMemo(() => {
    return uniqueArtists.sort(() => 0.5 - Math.random());
  }, [uniqueArtists]);

  return (
    <div className="artists">
      <h2>
        <T>sonicbox.artists</T>
      </h2>
      <div className="artists-container">
        {artists.map((artist) => (
          <button
            type="button"
            key={artist.songid}
            className="artist"
            onClick={() => handleSelectArtist(artist.artist)}
          >
            <LoadableImage
              src={artist.cover}
              alt={artist.artist}
              className="cover"
              altComponent={<DefaultArtistCover songid={artist.songid} />}
            />
            <span className="name">{artist.artist}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
